@if (displayedSubchart()) {
  <div #explorer class="explorer" data-automation="explorer">
    <div class="explorer-grid">
      @for (column of displayedSubchart().columns; let i = $index; track i) {
        <h4 class="explorer-column" data-automation="explorer-header">{{ column.header | translate }}</h4>
      }
    </div>
    <div class="explorer-grid">
      @for (supercolumn of displayedSubchart().supercolumns; let i = $index; track i) {
        <div class="explorer-supercolumn" [style.flex-grow]="supercolumn.columnIndexes.length">
          @for (row of supercolumn.rows; let j = $index; track j) {
            <div class="explorer-grid">
              @for (column of row.columns; let k = $index; track k) {
                <div class="explorer-column d-flex flex-column">
                  @for (node of column; let index = $index; track index) {
                    <div class="w-100">
                      <ziro-explorer-node
                        class="link w-100"
                        [ngClass]="{
                          'link__before--across': node.beforeConnection === 'across',
                          'link__before--downward': node.beforeConnection === 'downward',
                          'link__after--across': node.afterConnection === 'across',
                          'link__after--downward': node.afterConnection === 'downward',
                          'explorer-node-enabled': !node.disabled,
                          'explorer-node-disabled': node.disabled,
                        }"
                        [title]="node.title"
                        [label]="node.label"
                        [sublabel]="node.sublabel"
                        [warnings]="node.warnings"
                        [icon]="node.icon"
                        [disabled]="node.disabled"
                        [previousLink]="node.previousSubchartLink"
                        [nextLink]="node.nextSubchartLink"
                        [previouslyViewedSubchartId]="lastViewedSubchartId()"
                        [previouslyViewedTooltip]="node.previouslyViewedTooltip"
                        [audioFileUrls]="node.audioFileUrls"
                        [mediaDisabled]="node.mediaDisabled"
                        [activeGreetingAudioUrl]="activeGreetingAudioUrl()"
                        [activeGreetingAudioLoadingUrl]="activeGreetingAudioLoadingUrl()"
                        [activeGreetingAudioDownloadUrl]="activeGreetingAudioDownloadUrl()"
                        (linkClicked)="linkClicked($event)"
                        (playGreetingAudio)="playGreetingAudio.emit($event)"
                        (stopGreetingAudio)="this.stopGreetingAudio.emit()"
                        (downloadGreetingAudio)="downloadGreetingAudio.emit($event)"
                        [attr.data-automation]="'explorer-column-' + supercolumn.columnIndexes[k] + '-node'"
                      ></ziro-explorer-node>
                    </div>
                  }
                  @let fillerNode = isFillerNodeNeeded(column);
                  <div
                    class="flex-grow-1 w-100 link"
                    [ngClass]="{
                      'link__before--vertical': fillerNode.linkBefore,
                      'link__after--vertical': fillerNode.linkAfter,
                    }"
                  ></div>
                </div>
              }
            </div>
          } @empty {
            @if (supercolumn.alertForNoRows) {
              <div class="explorer-grid">
                <div class="explorer-column d-flex flex-column">
                  <div class="w-100">
                    <div
                      class="alert alert-info"
                      [innerHTML]="supercolumn.alertForNoRows | escapeHtml"
                      [attr.data-automation]="'explorer-column-' + supercolumn.columnIndexes[0] + '-no-nodes-alert'"
                    ></div>
                  </div>
                </div>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
}
